import React from 'react'

const Frontend = () => {
  return (
    <div className="skills__content">
        <h3 className="skills__title">Soft Skills</h3>

        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>

                <div>
                    <h3 className="skills__name"> Creative Problem-Solving</h3>
                    {/* <span className="skills__level">Advanced</span> */}
                </div>
                </div>
                
                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>

                <div>
                    <h3 className="skills__name">Deadline Management</h3>
                    {/* <span className="skills__level">Advanced</span> */}
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>

                <div>
                    <h3 className="skills__name">Clear Communication</h3>
                    {/* <span className="skills__level">Intermediate</span> */}
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>

                <div>
                    <h3 className="skills__name">Agile & Waterfall Methodologies</h3>
                    {/* <span className="skills__level">Intermediate</span> */}
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>

                <div>
                    <h3 className="skills__name">Stakeholder Analysis &
                    Engagement</h3>
                    {/* <span className="skills__level">Intermediate</span> */}
                </div>
                </div>
{/* 
                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>

                <div>
                    <h3 className="skills__name">React JS</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>


                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>

                <div>
                    <h3 className="skills__name">React JS</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div> */}

            </div>

            <div className="skills__group">
                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>

                <div>
                    <h3 className="skills__name">Technical Project Management</h3>
                    {/* <span className="skills__level">Advanced</span> */}
                </div>
                </div>
                
                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>

                <div>
                    <h3 className="skills__name">Business Analysis</h3>
                    {/* <span className="skills__level">Advanced</span> */}
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>

                <div>
                    <h3 className="skills__name">Interpersonal Skills</h3>
                    {/* <span className="skills__level">Advanced</span> */}
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>

                <div>
                    <h3 className="skills__name">Business Documentation</h3>
                    {/* <span className="skills__level">Advanced</span> */}
                </div>
                </div>

                <div className="skills__data">
                <i class='bx bx-badge-check' ></i>

                <div>
                    <h3 className="skills__name">Problem Solving</h3>
                    {/* <span className="skills__level">Advanced</span> */}
                </div>
                </div>

            </div>
        </div>
    </div>
  )
}

export default Frontend